import { Card } from 'antd';
import { Color, Text, Title } from '@bb/elements-web';
import styled from 'styled-components';

export const StyledCard = styled(Card)<{
  $bordered?: boolean;
  $centerText?: boolean;
  $noPadding?: boolean;
}>`
  background-color: white;
  border-radius: 8px;
  border: ${props => (props.$bordered ? '1px solid #d9d9d9' : 'none')};
  width: 343px;
  max-width: 90%;
  min-width: 320px;
  margin: 16px auto;
  text-align: ${props => (props.$centerText ? 'center' : 'left')};

  .ant-card-body {
    padding: ${props => (props.$noPadding ? '24px 0' : '24px')};
  }
`;

export const StyledText = styled(Text)<{
  $alignCenter?: boolean;
  $secondary?: boolean;
}>`
  display: block;
  text-align: ${props => (props.$alignCenter ? 'center' : 'left')};
  color: ${props => (props.$secondary ? Color.BODY_TEXT : Color.PRIMARY_TEXT)};
`;
